import { PageHero } from "../components/PageHero";
import { Reveal } from "../lib/motion";
import { FOUNDER, PRINCIPLES } from "../lib/data";
import { Mail, Quote, Linkedin } from "lucide-react";

export default function FoundersColumn() {
  return (
    <>
      <PageHero
        testid="founder-hero"
        overline="Founder's Column"
        title="A note from our Founder."
        subtitle={FOUNDER.headline}
      />

      <section className="bg-background py-24">
        <div className="container-x grid gap-14 lg:grid-cols-12">
          {/* Portrait + identity */}
          <Reveal className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <div
                data-testid="founder-portrait"
                className="relative aspect-[4/5] overflow-hidden rounded-2xl border border-border shadow-xl"
              >
                <img src="/brand/founder.jpg" alt={FOUNDER.name} className="h-full w-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/85 via-navy/10 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="font-display text-xl font-semibold text-white">{FOUNDER.name}</p>
                  <p className="text-sm text-white/80">{FOUNDER.title}</p>
                </div>
              </div>
              <div className="mt-5 flex flex-wrap items-center gap-3">
                <a
                  href={`mailto:${FOUNDER.email}`}
                  data-testid="founder-email"
                  className="inline-flex items-center gap-2 rounded-full border border-border px-5 py-2.5 text-sm font-medium transition-colors hover:border-accent hover:text-accent"
                >
                  <Mail className="h-4 w-4" /> {FOUNDER.email}
                </a>
                <a
                  href={FOUNDER.linkedin}
                  target="_blank" rel="noreferrer"
                  data-testid="founder-linkedin"
                  className="inline-flex items-center gap-2 rounded-full brand-gradient px-5 py-2.5 text-sm font-semibold text-white"
                >
                  <Linkedin className="h-4 w-4" /> LinkedIn
                </a>
              </div>
            </div>
          </Reveal>

          {/* Note */}
          <div className="lg:col-span-8">
            <Reveal>
              <Quote className="h-10 w-10 text-accent" />
            </Reveal>
            <div className="mt-6 space-y-6">
              {FOUNDER.note.map((para, i) => (
                <Reveal key={i} delay={i * 0.05}>
                  <p className={`leading-relaxed text-muted-foreground ${i === 0 ? "text-xl font-light text-foreground" : "text-lg font-light"}`}>
                    {para}
                  </p>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.2}>
              <div className="mt-10 border-t border-border pt-8">
                <p className="font-display text-2xl italic text-gradient">{FOUNDER.name}</p>
                <p className="mt-1 text-sm text-muted-foreground">{FOUNDER.title}, Zenspark Global Corporation</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Principles */}
      <section className="border-t border-border bg-secondary/40 py-24">
        <div className="container-x">
          <Reveal className="mb-12 max-w-2xl">
            <p className="overline text-gradient">What we stand for</p>
            <h2 className="mt-4 text-balance text-3xl font-semibold tracking-tighter sm:text-4xl">
              The principles behind every engagement.
            </h2>
          </Reveal>
          <div className="grid gap-px overflow-hidden rounded-2xl border border-border bg-border sm:grid-cols-2 lg:grid-cols-5">
            {PRINCIPLES.map((p, i) => {
              const Icon = p.icon;
              return (
                <Reveal key={p.title} delay={(i % 5) * 0.06} className="bg-background p-8">
                  <Icon className="h-6 w-6 text-accent" />
                  <h3 className="mt-5 text-lg font-semibold tracking-tight">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{p.desc}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
